(() => {
  if (window.AuziGuidePlayer) return;
  const pause = root => {
    const v=root?.querySelector('video');
    if(v && !v.paused) v.pause();
  };
  function sync(root) {
    const video=root?.querySelector('video');
    const toggle=root?.querySelector('[data-auzi-video-toggle]');
    if(!video||!toggle)return;
    const playing=!video.paused && !video.ended;
    root.classList.toggle('is-playing',playing);
    toggle.setAttribute('aria-label',playing?(toggle.dataset.pauseLabel||'Pause video'):(toggle.dataset.playLabel||'Play video'));
    toggle.setAttribute('aria-pressed',String(playing));
  }
  document.addEventListener('click',e=>{
    const videoButton=e.target.closest('[data-auzi-video-toggle]');
    if(videoButton){
      const root=videoButton.closest('[data-auzi-player]'),v=root?.querySelector('video');
      if(!v)return;
      if(v.paused){
        document.querySelectorAll('[data-auzi-player] video').forEach(other=>{if(other!==v)other.pause()});
        v.muted=false;
        v.play().catch(()=>sync(root));
      }else v.pause();
      return;
    }
    if(e.target.closest('[data-auzi-fit-open]')){
      const dialog=document.getElementById('auzi-fit-dialog');
      if(dialog && !dialog.open)dialog.showModal();
      return;
    }
    if(e.target.closest('[data-auzi-fit-close]')){
      document.getElementById('auzi-fit-dialog')?.close();
    }
  });
  document.addEventListener('play',e=>{if(e.target.matches?.('[data-auzi-player] video'))sync(e.target.closest('[data-auzi-player]'))},true);
  document.addEventListener('pause',e=>{if(e.target.matches?.('[data-auzi-player] video'))sync(e.target.closest('[data-auzi-player]'))},true);
  document.addEventListener('ended',e=>{if(e.target.matches?.('[data-auzi-player] video'))sync(e.target.closest('[data-auzi-player]'))},true);
  const init=()=>{
    const dialog=document.getElementById('auzi-fit-dialog');
    if(dialog && !dialog.dataset.bound){
      dialog.dataset.bound='1';
      dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close()});
      dialog.addEventListener('close',()=>{
        dialog.querySelectorAll('[data-auzi-player]').forEach(pause);
        document.querySelector('[data-auzi-fit-open]')?.focus({preventScroll:true});
      });
    }
    const opener=document.querySelector('[data-auzi-fit-opener]');
    if(opener){
      const desc=document.querySelector('main product-info .product__description');
      const fallback=document.querySelector('main product-info .product__title');
      if(desc && opener.previousElementSibling!==desc)desc.insertAdjacentElement('afterend',opener);
      else if(!desc&&fallback&&opener.previousElementSibling!==fallback)fallback.insertAdjacentElement('afterend',opener);
    }
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
  window.AuziGuidePlayer={init};
})();